import {listNotifications} from "../layout/vocuser-notifications"

export function menusMobile() {
  let seccion = window.nibara.nTools.getSectionUrl();
  Logger.debug('[menuMobile] seccion: ', seccion);
  if (seccion === 'blogs') {
      Voonto.$('.navegacion a.opinion').addClass('activo');
      Voonto.$('.navegacion a.opinion').next().next().show();
      Voonto.$('.navegacion a.opinion').next().addClass('rotado');
  } else if (seccion !== 'summum' && seccion !== 'guia-restaurantes') {
      Voonto.$('.navegacion a').removeClass('activo');
  }
  
  let navID = $('body').data('edicion');
  /*if (navID) {
    Voonto.$('.navegacion a.' + navID).addClass('activo');
    Voonto.$('.navegacion a.' + navID).next().next().show();
  }*/
  Voonto.$('[data-abre-navegacion]').click(function () {
    Voonto.$('.navegacion').stop().animate({right: '0'}, 350, 'linear');
  });
  Voonto.$('[data-cierra-navegacion]').click(function () {
    Voonto.$('.navegacion').stop().animate({right: '100%'}, 350, 'linear');
  });
  Voonto.$('[data-abre-siguiente]').click(function () {
    Voonto.$(this).next().slideToggle();
    Voonto.$(this).toggleClass('rotado');
  });
  Voonto.$('[data-boton-animado]').on('click', function(){
      let tipoAnimacion = Voonto.$(this).data('boton-animado');
      Logger.info('tipoAnimacion '+ tipoAnimacion);
      switch(tipoAnimacion) {
          case 'menu':
            Voonto.$(this).toggleClass('abierto');
      }
  });

  /** menu usuario y alertas function *******************************************************/
  Voonto.$('[data-abre-menu-usuario-login]').click(function(){
      Voonto.$('[data-menu-usuario-login]').addClass('visible');
      Voonto.$('[data-menu-alerta-login]').removeClass('visible');
  });
  Voonto.$('[data-abre-menu-alerta-login]').click(function(){
        listNotifications().then(function () {
            Voonto.$('[data-menu-usuario-login]').removeClass('visible');
            Voonto.$('[data-menu-alerta-login]').addClass('visible');
        });
  });
  Voonto.$('[data-cerrar-menu-usuario-login]').click(function(){Voonto.$('[data-menu-usuario-login]').removeClass('visible')});
  Voonto.$('[data-cerrar-menu-alerta-login]').click(function(){Voonto.$('[data-menu-alerta-login]').removeClass('visible')});
}

export function menusDesktop() {
    Logger.info ('[post-script] Init menusDesktop');
    let seccion = window.nibara.nTools.getSectionUrl();
    Logger.info ('[post-script] seccion: ' + seccion);

    var app = Voonto.getInstance();
    var siteType = app.lookup('vocento.site').type;
    if (siteType !== undefined) {
        Voonto.$('.main .titulo-seccion').css({
            'top': '-61px',
            'opacity': 1
        });
    } else {
        if (Voonto.$('.segundo-nivel').length && seccion !== 'summum') {
            Voonto.$('.main .titulo-seccion').css({
                'top': '-91px',
                'opacity': 1
            });
        } else {
            Voonto.$('.main .titulo-seccion').css('opacity', 1);
        }
    }

    Voonto.$('[data-mostrar]').on('click', function(){
      if (Voonto.$(this).data('mostrar') !== '') {
          Voonto.$(this).next().css('display', Voonto.$(this).data('mostrar'));
      } else {
          Voonto.$(this).next().show();
      }
    });

    Voonto.$('[data-cerrar]').on('click', function () {
        Voonto.$(this).parent().hide();
    });

    /** menu usuario y alertas function *******************************************************/
    let botonUsuarioLogin = Voonto.$('[data-abre-menu-usuario-login]'),
      botonAlertaLogin = Voonto.$('[data-abre-menu-alerta-login]'),
      menuUsuarioLogin = Voonto.$('[data-menu-usuario-login]'),
      menuAlertaLogin = Voonto.$('[data-menu-alerta-login]'),
      botonUsuarioLoginSticky = Voonto.$('[data-abre-menu-usuario-login-sticky]'),
      botonAlertaLoginSticky = Voonto.$('[data-abre-menu-alerta-login-sticky]'),
      menuUsuarioLoginSticky = Voonto.$('[data-menu-usuario-login-sticky]'),
      menuAlertaLoginSticky = Voonto.$('[data-menu-alerta-login-sticky]');

    botonUsuarioLogin.on('click', function() {
        Logger.info ('[post-script] botonUsuarioLogin click');
        Logger.info ('[post-script] botonUsuarioLogin: ' + botonUsuarioLogin);
        if(menuUsuarioLogin.hasClass('visible')) {
            Logger.info ('[post-script] menuUsuarioLogin has class visible');
            Voonto.$(this).removeClass('visible');
            menuUsuarioLogin.removeClass('visible');
        } else {
            Logger.info ('[post-script] menuUsuarioLogin not class visible');
            Voonto.$(this).addClass('visible');
            menuUsuarioLogin.addClass('visible');
            botonAlertaLogin.removeClass('visible');
            menuAlertaLogin.removeClass('visible');}
    });

    botonAlertaLogin.on('click', function() {
        Logger.info ('[post-script] botonAlertaLogin click');
        if(menuAlertaLogin.hasClass('visible')) {
            Voonto.$(this).removeClass('visible');
            menuAlertaLogin.removeClass('visible');
        } else {
          listNotifications().then(function () {
              Logger.debug('[vocuser-notifications] cambio menu');
              botonAlertaLogin.addClass('visible');
              menuAlertaLogin.addClass('visible');
              botonUsuarioLogin.removeClass('visible');
              menuUsuarioLogin.removeClass('visible');
          });
        }
    });

    botonUsuarioLoginSticky.on('click', function() {
        Logger.info ('[post-script] botonUsuarioLoginSticky click');
        if(menuUsuarioLoginSticky.hasClass('visible')) {
            Voonto.$(this).removeClass('visible');
            menuUsuarioLoginSticky.removeClass('visible');
        } else {
            Voonto.$(this).addClass('visible');
            menuUsuarioLoginSticky.addClass('visible');
            botonAlertaLoginSticky.removeClass('visible');
            menuAlertaLoginSticky.removeClass('visible');
        }
    });

    botonAlertaLoginSticky.on('click', function() {
        Logger.info ('[post-script] botonAlertaLoginSticky click');
        if(menuAlertaLoginSticky.hasClass('visible')) {
            Voonto.$(this).removeClass('visible');
            menuAlertaLoginSticky.removeClass('visible');
        } else {
            listNotifications().then(function () {
                botonAlertaLoginSticky.addClass('visible');
                menuAlertaLoginSticky.addClass('visible');
                botonUsuarioLoginSticky.removeClass('visible');
                menuUsuarioLoginSticky.removeClass('visible');
          });
        }
    });
}



// WEBPACK FOOTER //
// ./src/scripts/home/menus.js